import React from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import {
  Container,
  Typography,
  Grid,
  Card,
  Link,
  CardContent,
  Button,
} from '@mui/material';
//import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import HouseIcon from '@mui/icons-material/House';
import AgricultureIcon from '@mui/icons-material/Agriculture';
import HomeWorkIcon from '@mui/icons-material/HomeWork';
import ApartmentIcon from '@mui/icons-material/Apartment';
import WbShadeIcon from '@mui/icons-material/WbShade';
//import FamilyRestroomIcon from '@mui/icons-material/FamilyRestroom'; 
import ManIcon from '@mui/icons-material/Man';
import WomanIcon from '@mui/icons-material/Woman';
import HutIcon from '@mui/icons-material/Grass'; 
import OtherHousesIcon from '@mui/icons-material/OtherHouses';
import CabinIcon from '@mui/icons-material/Cabin';
import GiteIcon from '@mui/icons-material/Gite';
import VillaIcon from '@mui/icons-material/Villa';
import MapsHomeWorkIcon from '@mui/icons-material/MapsHomeWork';
import Diversity3Icon from '@mui/icons-material/Diversity3';
import DomainIcon from '@mui/icons-material/Domain';

import HomeIcon from '@mui/icons-material/Home';
import BarChartIcon from '@mui/icons-material/BarChart';
import Breadcrumbs from '@mui/material/Breadcrumbs';


const InfographicCard = ({ title, icon, total, urbain, rural }) => (
  <Card variant="outlined" sx={{ mb: 2, height: '100%', bgcolor: '#ffffff', boxShadow: 3, borderRadius: 2, transition: '0.3s', '&:hover': { boxShadow: 6 } }}>
    <CardContent>
      <Grid container alignItems="center">
        <Grid item xs={3} sx={{ textAlign: 'center' }}>
          {icon}
        </Grid>
        <Grid item xs={9}>
          <Typography variant="h6" fontWeight="bold" sx={{ color: '#000000' }}>
            {title}
          </Typography>
          <Typography variant="h4" sx={{ color: '#4CAF50', fontWeight: 'bold' }}>
            {total}
          </Typography>
          {urbain && rural && (
            <Typography variant="body2" sx={{ color: '#757575' }}>
              Urbain : {urbain} | Rural : {rural}
            </Typography>
          )}
        </Grid>
      </Grid>
    </CardContent>
  </Card>
);

function ResultatRGPHAE2024() {
  return (
    <div style={{ backgroundColor: '#f5f5f5', paddingBottom: '40px' }}>
      <NavigationBar />
        <Container maxWidth="lg" style={{ paddingTop: '10px' }}>
       {/* Fil d'Ariane */}
        <Breadcrumbs sx={{ mb: 3, color: '#555', paddingTop: '70px', paddingLeft: '20px', paddingBottom:'30px' }} aria-label="breadcrumb">
          <Link underline="hover" color="inherit" href="/" sx={{ display: 'flex', alignItems: 'center' }}>
            <HomeIcon sx={{ mr: 0.5 }} fontSize="small" />
            Accueil
          </Link>
          <Typography color="text.primary" sx={{ display: 'flex', alignItems: 'center' }}>
            <BarChartIcon sx={{ mr: 0.5 }} fontSize="small" />
            Résultats RGPHAE 2024
          </Typography>
        </Breadcrumbs>
    
        <Typography variant="h4" gutterBottom style={{color:'#008D36'}}>
          Résultats du RGPHAE - Édition 2024
        </Typography>

        <Typography variant="body1" paragraph>
  Le Burundi vient de publier les résultats préliminaires du Recensement Général de la Population, Habitat, Agriculture et Élevage (RGPHAE), édition 2024, conformément au 
  <Link 
    href="https://presidence.gov.bi/2025/04/03/decret-n0-100-032-du-27-mars-2025-portant-publication-des-resultats-preliminaires-du-recensement-general-de-la-population-de-lhabitat-de-lagriculture-et-de-lelevage-au-burundi-edition-2024-r/" 
    underline="hover" 
    target="_blank" 
    rel="noopener noreferrer"
  >
    Décret N0 100/032 du 27 mars 2025 portant publication des résultats préliminaires du Recensement Général de la Population, De l'Habitat, de l'Agriculture et de l'Élevage au Burundi, édition 2024 (RGPHAE, 2024)
  </Link>.
</Typography>

        {/* Bouton pour les résultats détaillés */}
        <Button 
          variant="contained" 
          color="primary" 
          href="/RGPHAEDataPage"
          sx={{ 
            mt: 2, 
            mb: 4,
            mr: 4,
          backgroundColor: '#008D36',
            '&:hover': {
              backgroundColor: '#008D36'
            }
          }}
        >  Résultats détaillés RGPHAE 2024
       
        </Button>
         <Button 
          variant="contained" 
          color="primary" 
          href="/populationDataPageBurundi"
          sx={{ 
            mt: 2, 
            mb: 4,
            mr: 4,
            backgroundColor: '#008D36',
            '&:hover': {
              backgroundColor: '#008D36'
            }
          }}
        >
            Pop. par Provinces / Communes / Collines RGPHAE 2024
        </Button>
         <Button 
          variant="contained" 
          color="primary" 
          href="/rapportModulesAgricoles"
          sx={{ 
            mt: 2, 
            mb: 4,
         
           backgroundColor: '#008D36',
            '&:hover': {
              backgroundColor: '#008D36'
            }
          }}
        >
          Rapports des Modules Agricoles RGPHAE
        </Button>

        {/* Section Populations */}
        <Typography variant="h5" fontWeight="bold" gutterBottom sx={{ mt: 4 , mb: 4 }}>
          Population
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <InfographicCard
              title="Population totale"
              icon={<Diversity3Icon  sx={{ color: '#4CAF50', fontSize: '60px' }} />}
              total="12,332,788"
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <InfographicCard
              title="Hommes"
              icon={<ManIcon sx={{ color: '#4CAF50', fontSize: '60px' }} />}
              total="5,901,069"
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <InfographicCard
              title="Femmes"
              icon={<WomanIcon sx={{ color: '#4CAF50', fontSize: '60px' }} />}
              total="6,431,719"
            />
          </Grid>
        </Grid>

        {/* Section Ménages */}
        <Typography variant="h5" fontWeight="bold" gutterBottom sx={[{ mt: 4, mb: 4 }]}>
           Population  par Type de Ménages
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <InfographicCard
              title="Ménages Ordinaires"
              icon={<HomeWorkIcon sx={{ color: '#4CAF50', fontSize: '60px' }} />}
              total="12,220,934"
              urbain="2,990,465"
              rural="9,230,469"
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <InfographicCard
              title="Ménages Collectifs"
              icon={<DomainIcon  sx={{ color: '#4CAF50', fontSize: '60px' }} />}
              total="109,603"
              urbain="85,024"
              rural="24,579"
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <InfographicCard
              title="Sans Abri"
              icon={<HutIcon  sx={{ color: '#4CAF50', fontSize: '60px' }} />}
              total="2,251"
              urbain="2,104"
              rural="147"
            />
          </Grid>
        </Grid>

        {/* Section Habitat */}
        <Typography variant="h5" fontWeight="bold" gutterBottom sx={[{ mt: 4, mb: 4 }]}>
          Types d'Habitat
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <InfographicCard
              title="Maisons Ordinaires"
              icon={<GiteIcon sx={{ color: '#4CAF50', fontSize: '60px' }} />}
              total="2,396,931"
              urbain="472,863"
              rural="1,924,068"
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <InfographicCard
              title="Immeubles d'Appartements"
              icon={<ApartmentIcon sx={{ color: '#4CAF50', fontSize: '60px' }} />}
              total="7,567"
              urbain="4,685"
              rural="2,882"
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <InfographicCard
              title="Villas Simples"
              icon={<HouseIcon sx={{ color: '#4CAF50', fontSize: '60px' }} />}
              total="66,350"
              urbain="55,015"
              rural="11,335"
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <InfographicCard
              title="Villas avec Étage"
              icon={<VillaIcon sx={{ color: '#4CAF50', fontSize: '60px' }} />}
              total="7,990"
              urbain="7,774"
              rural="216"
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <InfographicCard
              title="Maisons en Bande"
              icon={<DomainIcon  sx={{ color: '#4CAF50', fontSize: '60px' }} />}
              total="181,156"
              urbain="138,908"
              rural="42,336"
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <InfographicCard
              title="Cases"
              icon={<WbShadeIcon sx={{ color: '#4CAF50', fontSize: '60px' }} />} 
              total="42,336"
              urbain="3,543"
              rural="38,793"
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <InfographicCard
              title="Huttes"
              icon={<CabinIcon sx={{ color: '#4CAF50', fontSize: '60px' }} />}
              total="17,910"
              urbain="2,750"
              rural="15,160"
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <InfographicCard
              title="Logements dans une Ferme"
              icon={<AgricultureIcon sx={{ color: '#4CAF50', fontSize: '60px' }} />}
              total="1,678"
              urbain="974"
              rural="704"
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <InfographicCard
              title="Autres Types d'Habitats"
              icon={<OtherHousesIcon sx={{ color: '#4CAF50', fontSize: '60px' }} />}
              total="2,677"
              urbain="1,991"
              rural="686"
            />
          </Grid>
        </Grid>

        {/* Section Agriculture */}
        <Typography variant="h5" fontWeight="bold" gutterBottom sx={[{ mt: 4, mb: 2 }]}>
          Ménages et Agriculture 
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <InfographicCard
              title="Ménages ordinaires"
              icon={<HomeWorkIcon sx={{ color: '#4CAF50', fontSize: '60px' }} />}
              total="2,724,457"
              urbain="688,425"
              rural="2,036,032"
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <InfographicCard
              title="Ménages Agricoles"
              icon={<AgricultureIcon sx={{ color: '#4CAF50', fontSize: '60px' }} />}
              total="2,335,995"
              urbain="390,809"
              rural="1,945,186"
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <InfographicCard
              title="Ménages Non Agricoles"
              icon={<MapsHomeWorkIcon sx={{ color: '#4CAF50', fontSize: '60px' }} />}
              total="388,462"
              urbain="297,616"
              rural="90,846"
            />
          </Grid>
        </Grid>
      </Container>
      <br />
      <br />
      <Footer />
    </div>
  );
}

export default ResultatRGPHAE2024;